//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#COMPUTE}\n\
 *\n\
 * @name czm_passCompute\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passCompute = 1.0;\n\
";
